<template>
  <div>
    <div>
      <swipers
        :swiper-data="homeData.ads && homeData.ads.bannerAds"
        @onSlideChange="slideChange"
      >
        <template v-slot:default="slotProps">
          <div
            class="bgBanner"
            @click="goHref(slotProps.item)"
            :style="{
              backgroundImage: `url(${imgRules(
                slotProps.item.adImageUrl,
                require('@/assets/images/banner1.png')
              )})`,
            }"
          >
            <div class="baner1Text">
              <div
                :class="
                  slideIndex === slotProps.item.index
                    ? 'animate__slideInLeft'
                    : ''
                "
                class="t1 animate__animated cl0f"
              >
                {{ slotProps.item.adTitle }}
              </div>
              <div
                :class="
                  slideIndex === slotProps.item.index
                    ? 'animate__slideInRight'
                    : ''
                "
                class="t2 animate__animated"
              >
                {{ slotProps.item.adSummary }}
              </div>
            </div>
          </div>
        </template>
      </swipers>
    </div>

    <div class="pt66 pb66 bgf3" ref="section">
      <navTitle
        class="op0"
        :class="getAnimationClass('section', 'animate__fadeInUp')"
        title="平台特色功能"
      ></navTitle>
      <div
        class="carList disf op0"
        :class="getAnimationClass('section', 'animate__fadeInUp ')"
      >
        <div
          class="cars hoverBox"
          v-for="(item, index) in countList"
          :key="index"
          @click="goRouter(item.path)"
        >
          <div>
            <img :src="item.icon" width="80px" height="80px" />
          </div>
          <div class="t">{{ item.name }}</div>
          <div class="n">{{ item.text }}</div>
          <div class="but" @click.stop="goMyPath(item.butPath)">{{ item.butText }}</div>
        </div>
      </div>
    </div>

    <div class="pt66 bgff pb68" ref="section4">
      <navTitle
        title="信息服务"
        class="op0"
        :class="getAnimationClass('section4', 'animate__fadeInUp')"
      ></navTitle>
      <div class="tableList">
        <div
          class="tc"
          :class="
            getAnimationClass(
              'section4',
              'animate__fadeInUp animate__delay-05s'
            )
          "
        >
          <ul class="disf tableTitleList">
            <li
              :class="{ actives: actives === index }"
              @click="changeTitle(index)"
              v-for="(item, index) in informationTiles"
              :key="index"
              class="disf disfac"
            >
              <img :src="item.icon" width="30px" height="30px" class="mr5" />
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="common-pub-button" v-if="actives === 0">
          <p
            class="buts curp"
            @click="$goPath('/infoManage/cargoSourceMyInfo')"
          >
            <span class="common-add">+</span>发布货源
          </p>
        </div>
        <div class="common-pub-button" v-if="actives === 1">
          <p
            class="buts curp"
            @click="$goPath('/infoManage/vehicleSourceMyInfo')"
          >
            <span class="common-add">+</span>发布车源
          </p>
        </div>
        <div @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            :class="
              getAnimationClass(
                'section4',
                'animate__fadeInUp animate__delay-1s'
              )
            "
          >
            <swiper-slide>
              <div class="swiper-conta">
                <div class="h230">
                  <div
                    class="disf disfjb disfac list"
                    v-for="(item, index) in cargoList"
                    :key="index"
                  >
                    <p
                      class="textSpace"
                      :title="item.loadingPlace + '-' + item.unloadingPlace"
                    >
                      {{ item.loadingPlace }} - {{ item.unloadingPlace }}
                    </p>
                    <p class="textSpace tc">{{ item.cargoName }}</p>
                    <p class="textSpace tc">¥电议</p>
                    <p class="textSpace tc">{{ item.publishTime }}</p>
                    <p class="tc">
                      <span
                        class="buts curp"
                        @click="$goPath('/infoManage/cargoSourceAllInfo')"
                        >{{
                          userInfo.account ? "点击" : "登录后"
                        }}查看联系方式</span
                      >
                    </p>
                  </div>
                </div>
                <div
                  class="common-more"
                  @click="$goPath('/infoManage/cargoSourceAllInfo')"
                >
                  <span class="text-more">更多</span>
                  <span class="more-img"></span>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiper-conta">
                <div class="h230">
                  <div
                    class="disf disfjb disfac list"
                    v-for="(item, index) in vehicleList"
                    :key="index"
                  >
                    <p
                      class="textSpace"
                      :title="item.loadingPlace + '-' + item.unloadingPlace"
                    >
                      {{ item.loadingPlace }} - {{ item.unloadingPlace }}
                    </p>
                    <p class="textSpace tc">
                      {{ item.trailerTypeName }} ｜ {{ item.trailerStyleName }}
                    </p>
                    <p class="textSpace tc">¥电议</p>
                    <p class="textSpace tc">{{ item.publishTime }}</p>
                    <p class="tc">
                      <span
                        class="buts curp"
                        @click="$goPath('/infoManage/vehicleSourceAllInfo')"
                        >{{
                          userInfo.account ? "点击" : "登录后"
                        }}查看联系方式</span
                      >
                    </p>
                  </div>
                </div>
                <div
                  class="common-more"
                  @click="$goPath('/infoManage/vehicleSourceAllInfo')"
                >
                  <span class="text-more">更多</span>
                  <span class="more-img"></span>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="tableList2">
        <div
          class="tc"
          :class="
            getAnimationClass(
              'section4',
              'animate__fadeInUp animate__delay-05s'
            )
          "
        >
          <ul class="disf tableTitleList">
            <li
              v-for="(item, index) in informationTiles2"
              :key="index"
              class="disf disfac"
            >
              <img :src="item.icon" width="30px" height="30px" class="mr5" />
              {{ item.title }}
            </li>
          </ul>
        </div>

        <div @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
          <div class="hs-common-title2">我需要护送</div>
          <div class="hs-common-title">我能做护送</div>
          <swiper
            :options="swiperOption"
            ref="mySwiper2"
            :class="
              getAnimationClass(
                'section4',
                'animate__fadeInUp animate__delay-1s'
              )
            "
          >
            <swiper-slide>
              <div class="swiper-conta">
                <div class="disf h250">

                  <div class="flex1  p1" >
                    <div class="p1 disfjb disf mt10">
                      <div class="common-pub-button">
                        <p
                            class=" curp"
                            @click="$goPath('/infoManage/escortSupplyMy')"
                        >
                          <span class="common-add">+</span>发布供给信息
                        </p>
                      </div>
                      <div
                          class="common-more"
                          @click="$goPath('/infoManage/escortSupplyAll')"
                      >
                        <span class="text-more">更多</span>
                        <span class="more-img"></span>
                      </div>
                    </div>

                    <div
                      class="disf disfjb disfac list hs-list2"
                      v-for="(item, index) in escortSupports"
                      :key="index"
                    >
                      <p class="textSpace tc">{{ item.publishTime }}</p>
                      <p class="tc">
                        <span
                          v-if="item.escortDescription !== ''"
                          :title="item.escortDescription"
                          class="buts curp escortDescription"
                          @click="$goPath('/infoManage/escortRequirementsAll')"
                          >{{ item.escortDescription }}</span
                        >
                        <span
                          v-else
                          class="buts curp escortDescription"
                          @click="$goPath('/infoManage/escortRequirementsAll')"
                        >
                          我能做护送
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="wd60" >
                    <div class="p1 disfjb disf mt10 " style="padding-left: 20px">
                      <div class="common-pub-button">
                        <p
                            class=" curp"
                            @click="$goPath('/infoManage/escortRequirementsMy')"
                        >
                          <span class="common-add">+</span>发布护送信息
                        </p>
                      </div>
                      <div
                          class="common-more"
                          @click="$goPath('/infoManage/escortRequirementsAll')"
                      >
                        <span class="text-more">更多</span>
                        <span class="more-img"></span>
                      </div>
                    </div>
                    <div
                      class="disf disfjb disfac list hs-list"
                      v-for="(item, index) in escortDemands"
                      :key="index"
                    >
                      <p class="textSpace" :title="item.loadingPlace">
                        {{ item.loadingPlace }}
                      </p>
                      <p v-if="item.escortDescription !== ''" class="textSpace" :title="item.escortDescription">
                        {{ item.escortDescription }}
                      </p>
                      <p v-else class="textSpace" title="我需要护送">
                        我需要护送
                      </p>
                      <p class="textSpace tc">¥电议</p>
                      <!-- <p class="textSpace tc">{{ item.publishTime }}</p> -->
                      <p class="tc">
                        <span
                          class="buts curp"
                          @click="$goPath('/infoManage/escortSupplyAll')"
                          >{{
                            userInfo.account ? "点击" : "登录后"
                          }}查看联系方式</span
                        >
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <news></news>
  </div>
</template>
<script>
import navTitle from "@/components/navTitle/index.vue";
import swipers from "@/components/swipers/index.vue";
import news from "./news.vue";
import { observers } from "@/mixins/observers";

import { getHome, getNewsInfo } from "@/api/home/index";
import { setImgPath, imgRules } from "@/utils/index";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
export default {
  name: "index",
  mixins: [observers],
  data() {
    return {
      slideIndex: 0,
      homeData: {},
      informationTiles: [
        {
          title: "货源信息",
          icon: require("@/assets/images/information-icon1.png"),
        },
        {
          title: "车源信息",
          icon: require("@/assets/images/information-icon2.png"),
        },
        // {
        //   title: "护送供需榜",
        //   icon: require("@/assets/images/information-icon3.png"),
        // },
      ],
      informationTiles2: [
        {
          title: "护送供需榜",
          icon: require("@/assets/images/information-icon3.png"),
        },
      ],
      swiperOption: {
        // API
        loop: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 500000,
        },
        on: {
          slideChangeTransitionStart: () => {
            if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
              this.actives = this.$refs.mySwiper.$swiper.realIndex;
            }
          },
        },
      },
      cargoList: [], //货源
      vehicleList: [], // 车源
      escortDemands: [], // 护送
      escortSupports: [], // 护送供给
      countList: [
        {
          name: "智能选线",
          num: 6,
          key: "enterpriseCount",
          icon: require("@/assets/images/feature-icon1.png"),
          path: "/project/line",
          butPath: "/auxiliary/linePlan",
          butText: "免费体验",
          text: "智能选线大模型快速评估路线可通行过性，让您选出的运输线路更快获批",
        },
        {
          name: "智能填报",
          num: 6,
          key: "vehicleSourceCount",
          path: "/project/declare",
          butPath: "/declare/generate",
          butText: "免费体验",
          icon: require("@/assets/images/feature-icon2.png"),
          text: "大件运输许可办证资料，从今天起可以一键生成啦！授权委托书、不可解体运单、车货轮廓图制作、护送方案等资料均可一键生成，快来体验吧！",
        },
        {
          name: "信息服务",
          key: "cargoSourceCount",
          num: 6,
          path: "/project/msg",
          butPath: "/infoManage/cargoSourceMyInfo",
          butText: "免费体验",
          icon: require("@/assets/images/feature-icon3.png"),
          text: "一手大件货源、车源、大件护送“供”、“需”信息集散平台，这里有最优质的货源、车源，大件运输来“大件物流数智平台”就对了",
        },
        {
          name: "数字路勘",
          num: 6,
          icon: require("@/assets/images/feature-icon4.png"),
          key: "escortDemandCount",
          path: "/project/szlk",
          butPath: "",
          butText: "内测中",
          text: "系统通过车货可通行性AI评估计算，结合路网高精地图数据，智能生成数字路勘报告，让您的通行申请获批更容易，运输更放心",
        },
      ],
      pageObj: {
        pageNo: 1,
        pageSize: 4,
      },
      actives: 0,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    goMyPath(path) {
      if(path !== '') {
        this.$goPath(path)
      }
    },
    setImgPath,
    goHref(item) {
      window.open(item.adLinkUrl);
    },
    stopAutoplay() {
      const swiper = this.$refs.mySwiper.$swiper;
      if (swiper && swiper.autoplay) {
        swiper.autoplay.stop();
      }
    },
    startAutoplay() {
      const swiper = this.$refs.mySwiper.$swiper;
      if (swiper && swiper.autoplay) {
        swiper.autoplay.start();
      }
    },
    changeTitle(i) {
      console.log(i);
      this.actives = i;
      this.$refs.mySwiper.$swiper.slideTo(i);
    },
    slideChange(e) {
      this.slideIndex = e;
    },
    async getList() {
      const { data } = await getHome();
      this.homeData = data;
    },
    goRouter(path) {
      this.$router.push({ path: path });
    },
    async getNewsInfoList() {
      const { data } = await getNewsInfo({ limit: 5 });
      this.cargoList = data.cargoSources;
      this.vehicleList = data.vehicleSources;
      this.escortDemands = data.escortDemands;
      this.escortSupports = data.escortSupports;
    },
    imgRules,
  },
  mounted() {
    this.getList();
    this.getNewsInfoList();
  },
  components: {
    SwiperSlide,
    Swiper,
    navTitle,
    swipers,
    news,
  },
};
</script>


<style scoped lang="less">
.bgBanner {
  background: url("../../assets/images/banner1.png") center no-repeat;
  background-size: cover;
  width: 100%;
  height: 565px;
  position: relative;
  .baner1Text {
    width: 26.3%;
    position: absolute;
    margin-top: 9.5%;
    margin-left: 20.5%;
    text-align: left;
    .t1 {
      font-size: 64px;
      font-weight: 600;
    }
    .t2 {
      font-size: 32px;
      margin-top: 20px;
      max-width: 450px;
      line-height: 50px;
      letter-spacing: 2px;
    }
  }
}

.carList {
  width: 1200px;
  margin: 0 auto;
  margin-top: 60px;
  justify-content: space-between;
  .cars {
    width: 290px;
    height: 457px;
    color: #000000;
    background: #ffffff;
    position: relative;
    cursor: pointer;
    border-radius: 8px;
    text-align: center;
    overflow: hidden;
    padding: 38px 20px 26px 20px;

    .t {
      font-size: 24px;
      font-weight: 600;
    }
    .n {
      font-size: 18px;
      line-height: 29px;
      letter-spacing: 1px;
      padding: 0 10px;
      margin-top: 10px;
    }
    .but {
      background: #0fb1c0;
      color: #ffffff;
      padding: 12px;
      border-radius: 2px;
      width: calc(100% - 40px);
      position: absolute;
      bottom: 26px;
      left: 20px;
      font-size: 18px;
      z-index: 999;
    }
  }
}
.bgBanner2 {
  background: url("../../assets/images/banner2.jpeg") center no-repeat;
  background-size: cover;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  position: relative;
  .baner2Text {
    width: 411px;
    position: absolute;
    top: 285px;
    right: 21.69%;
    text-align: left;
    transform: translate(50%, -50%);
    .t1 {
      font-size: 48px;
      font-weight: 600;
      color: #ffffff;
    }
    .t2 {
      font-size: 26px;
      margin-top: 10px;
      color: #ffffff;
    }
    .buts {
      padding: 10px 40px;
      background: #348edf;
      color: #ffffff;
      display: inline-block;
      border-radius: 4px;
      margin-top: 26px;
      cursor: pointer;
    }
  }
}

.bgBanner3,
.bgBanner4 {
  background: url("../../assets/images/banner3.jpeg") center no-repeat;
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: relative;
  .bgBanner3Cont {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding-left: 20px;
    position: relative;
    .baner3Text {
      width: 580px;
      height: 380px;
      text-align: left;
      position: absolute;
      margin-top: -190px;
      margin-left: 10px;
      top: 50%;
      padding: 42px 42px 0 50px;
      background: linear-gradient(136deg, #3fa4e8 0%, #348edf 100%);
      border-radius: 4px 9px 4px 32px;
      .title {
        display: inline-block;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
        margin-bottom: 17px;
        padding-bottom: 10px;
      }
      .t1 {
        font-size: 48px;
        font-weight: 600;
        color: #0f3eaa;
      }
      .t2 {
        font-size: 26px;
        margin-top: 10px;
        color: #0f3eaa;
      }
      .buts {
        padding: 10px 40px;
        background: #ffffff;
        color: #348edf;
        display: inline-block;
        border-radius: 4px;
        margin-top: 16px;
        cursor: pointer;
        font-weight: 600;
      }
    }
  }
}
.bgBanner4 {
  background: url("../../assets/images/banner4.jpeg") center no-repeat;
  background-size: cover;
  .bgBanner3Cont {
    .baner3Text {
      right: 20px;
      background: linear-gradient(135deg, #1b4dc1 0%, #0f3eaa 100%);
      .buts {
        color: #103fac;
        cursor: pointer;
        margin-top: 40px;
      }
    }
  }
}
.h240 {
  height: 240px !important;
}
.tableList {
  width: 1200px;
  margin: 0 auto;
  margin-top: 60px;
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  // padding-bottom: 50px;
  height: 398px;
  background: url("../../assets/images/tableBg2.png") no-repeat;
  background-size: cover;
  position: relative;

  .common-pub-button {
    position: absolute;
    right: 26px;
    top: 20px;
    height: 36px;
    line-height: 36px;
    padding: 0 30px 0 20px;
    background: rgba(255, 255, 255, 0.31);
    border-radius: 2px;
    border: 1px solid #0fb1c0;
    color: #0fb1c0;
    font-size: 16px;

    .common-add {
      font-size: 26px;
      margin-right: 10px;
      display: inline-block;
      vertical-align: top;
    }
  }

  .tableTitleList {
    width: 100%;
    border-bottom: 1px solid #c3d7f6;
    li {
      margin-right: 70px;
      cursor: pointer;
      font-size: 24px;
      font-weight: 600;
      padding: 0 0 10px 0;

      &:hover {
        .actives;
      }
    }
    .actives {
      color: #0fb1c0;
      position: relative;
      &:after {
        display: block;
        content: " ";
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 3px;
        background: #0fb1c0;
        border-radius: 3px;
      }
    }
  }
  .swiper-conta {
    .common-more {
      height: 50px;
      border-top: 1px solid #c3d7f6;
      padding: 0 25px;
      margin-top: 20px;
      text-align: center;
      line-height: 50px;

      .text-more {
        font-weight: 600;
        font-size: 16px;
        color: #0fb1c0;
        cursor: pointer;
        letter-spacing: 1px;
      }

      .more-img {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url("~@/assets/images/more.png") no-repeat center;
        background-size: cover;
        margin-left: 4px;
        vertical-align: text-top;
        cursor: pointer;
        margin-top: 1px;
      }
    }
    .nav {
      border-bottom: 1px solid #c3d7f6;
      padding-bottom: 10px;
    }
    .list {
      flex-wrap: wrap;
      margin-top: 15px;
      .buts {
        border: 1px solid #0fb1c0;
        display: inline-block;
        // padding: 3px 10px;
        color: #0fb1c0;
        cursor: pointer;
      }
      p {
        padding-right: 10px;
        line-height: 32px;
        cursor: pointer;

        &:nth-child(1) {
          width: 30%;
          font-weight: 600;
        }
        &:nth-child(2) {
          width: 20%;
        }
        &:nth-child(3) {
          width: 10%;
        }
        &:nth-child(4) {
          width: 20%;
        }
        &:nth-child(5) {
          width: 20%;
          font-weight: 600;
        }
      }
    }
    .hs-list {
      margin-left: 72px;
      p {
        &:nth-child(4) {
          width: 35%;
        }
      }
    }
    .hs-list2 {
      margin-left: 40px;
      p {
        &:nth-child(1) {
          width: 30%;
        }
        &:nth-child(2) {
          width: 70%;
        }
      }
    }
    .buts {
      padding: 0 20px;
      border: 1px solid #0fb1c0;
      font-size: 18px;
      span {
        font-size: 22px;
        font-weight: 600;
        margin-right: 3px;
        display: inline-block;
        vertical-align: top;
      }
    }
  }

  .title,
  .more {
    width: 50px;
    height: 210px;
    border-radius: 8px 0px 0px 8px;
    background: #0f3eaa;
    color: #ffffff;
    font-size: 26px;
    letter-spacing: 5px;
    display: flex;
    text-align: center;
    padding-left: 6px;
    align-items: center;
    cursor: pointer;
  }
  .more {
    background: transparent;
    border: 1px solid #0fb1c0;
    border-radius: 0 8px 8px 0;
    color: #0fb1c0;
  }
  .bg34 {
    background: #348edf !important;
  }
  .bg0f {
    background: #0fb1c0 !important;
  }
  .list {
    display: flex;

    .items {
      width: 258px;
      height: 210px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #c2c2c2;
      padding: 20px 19px;
      position: relative;
      margin-left: 14px;
      .itemTitle {
        max-height: 66px;
        min-height: 46px;
      }
      .bottoms {
        position: absolute;
        width: 100%;
        bottom: 10px;
        left: 0;
        padding-left: 19px;
      }
    }
    .loginBut {
      padding: 7px 14px;
      border-radius: 2px;
      border: 1px solid rgba(15, 177, 192, 0.37);
      font-weight: 600;
      font-size: 16px;
      color: #0fb1c0;
      cursor: pointer;
      display: inline-block;
    }
  }
}

.tableList2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  height: 398px;
  background: url("../../assets/images/tableBg3.png") no-repeat;
  background-size: cover;
  position: relative;

  .common-pub-button {
    height: 36px;
    line-height: 36px;
    width: 190px;
    padding: 0 30px 0 20px;
    background: rgba(255, 255, 255, 0.31);
    border-radius: 2px;
    border: 1px solid #0fb1c0;
    color: #0fb1c0;
    font-size: 16px;

    .common-add {
      font-size: 26px;
      margin-right: 10px;
      display: inline-block;
      vertical-align: top;
    }
  }

  .tableTitleList {
    width: 100%;
    border-bottom: 1px solid #c3d7f6;
    li {
      margin-right: 70px;
      cursor: pointer;
      font-size: 24px;
      font-weight: 600;
      padding: 0 0 10px 0;
      color: #0fb1c0;
    }
    .actives {
      color: #0fb1c0;
      position: relative;
      &:after {
        display: block;
        content: " ";
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 3px;
        background: #0fb1c0;
        border-radius: 3px;
      }
    }
  }
  .swiper-conta {
    .common-more {
      height: 40px;
      text-align: center;
      line-height: 40px;

      .text-more {
        font-weight: 600;
        font-size: 16px;
        color: #0fb1c0;
        cursor: pointer;
        letter-spacing: 1px;
      }

      .more-img {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url("~@/assets/images/more.png") no-repeat center;
        background-size: cover;
        margin-left: 4px;

        cursor: pointer;
        margin-top: 1px;
      }
    }
    .nav {
      border-bottom: 1px solid #c3d7f6;
      padding-bottom: 10px;
    }
    .list {
      flex-wrap: wrap;
      margin-top: 15px;
      .buts {
        border: 1px solid #0fb1c0;
        display: inline-block;
        // padding: 3px 10px;
        color: #0fb1c0;
        cursor: pointer;
      }
      p {
        cursor: pointer;

        &:nth-child(1) {
          width: 30%;
          font-weight: 600;
        }
        &:nth-child(2) {
          width: 20%;
        }
        &:nth-child(3) {
          width: 10%;
        }
        &:nth-child(4) {
          width: 20%;
        }
        &:nth-child(5) {
          width: 20%;
          font-weight: 600;
        }
      }
    }
    .hs-list {
      margin-left: 72px;
      p {
        &:nth-child(4) {
          width: 35%;
        }
      }
    }
    .hs-list2 {
      margin-left: 40px;
      p {
        &:nth-child(1) {
          width: 30%;
        }
        &:nth-child(2) {
          width: 70%;
        }
      }
    }
    .buts {
      padding: 4px 20px;
      border: 1px solid #0fb1c0;
      font-size: 18px;
      font-weight: 600;
      span {
        font-size: 22px;
        font-weight: 600;
        margin-right: 3px;
        display: inline-block;
        vertical-align: top;
      }
    }
  }

  .title,
  .more {
    width: 50px;
    height: 210px;
    border-radius: 8px 0px 0px 8px;
    background: #0f3eaa;
    color: #ffffff;
    font-size: 26px;
    letter-spacing: 5px;
    display: flex;
    text-align: center;
    padding-left: 6px;
    align-items: center;
    cursor: pointer;
  }
  .more {
    background: transparent;
    border: 1px solid #0fb1c0;
    border-radius: 0 8px 8px 0;
    color: #0fb1c0;
  }
  .bg34 {
    background: #348edf !important;
  }
  .bg0f {
    background: #0fb1c0 !important;
  }
  .list {
    display: flex;

    .items {
      width: 258px;
      height: 210px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #c2c2c2;
      padding: 20px 19px;
      position: relative;
      margin-left: 14px;
      .itemTitle {
        max-height: 66px;
        min-height: 46px;
      }
      .bottoms {
        position: absolute;
        width: 100%;
        bottom: 10px;
        left: 0;
        padding-left: 19px;
      }
    }
    .loginBut {
      padding: 7px 14px;
      border-radius: 2px;
      border: 1px solid rgba(15, 177, 192, 0.37);
      font-weight: 600;
      font-size: 16px;
      color: #0fb1c0;
      cursor: pointer;
      display: inline-block;
    }
  }
}
.bgbor {
  background: rgba(15, 177, 192, 0.24);
  border-radius: 12px;
  color: #0fb1c0;
  display: inline-block;
  padding: 3px 12px;
  font-size: 12px;
}
.w80 {
  width: 80px;
}

.w138 {
  width: 138px;
}
.mxh40 {
  max-height: 40px;
}
.bgf3 {
  background: #f3f7ff;
}

.wd60 {
  width: 60% !important;
}

.flex1 {
  flex: 1;
}

.font0 {
  font-size: 0;
}

.hs-common-title {
  width: 36px;
  height: 221px;
  padding: 0 10px;
  background: #c1ecf1;
  border-radius: 3px;
  font-weight: 600;
  font-size: 18px;
  color: #0fb1c0;
  display: flex;
  justify-items: center;
  align-items: center;
  position: absolute;
  left: 24px;
  top: 142px;
  z-index: 100;
}

.hs-common-title2 {
  width: 36px;
  height: 221px;
  padding: 0 10px;
  background: #c1ecf1;
  border-radius: 3px;
  font-weight: 600;
  font-size: 18px;
  color: #0fb1c0;
  display: flex;
  justify-items: center;
  align-items: center;
  position: absolute;
  left: 42%;
  top: 142px;
  z-index: 100;
}

.dis-inline {
  display: inline-block;
  vertical-align: top;
}

.h230 {
  height: 230px;
}

.h250 {
  height: 250px;
}

.pb68 {
  padding-bottom: 68px;
}

.escortDescription {
  display: inline-block;
  width: 275px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>